/**
 * API Utility Functions
 */

export const getApiBaseUrl = (): string => {
  return import.meta.env.VITE_API_URL || 'https://rafal-hcs-backend.sass.cyparta.com/api/v1';
  // return 'http://localhost:8000/api/v1';
};

